import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromModules from './module.reducer';

export const selectModulesState = createSelector(selectDashboardState, (dashboard) => dashboard?.modules);

export const selectModules = createSelector(selectModulesState, fromModules.selectAll);

export const selectModulesInSelectedIntervention = createSelector(
  selectModulesState,
  (moduleState) => moduleState?.modulesInSelectedIntervention
);

export const selectSelectedModule = createSelector(selectModulesState, (moduleState) => moduleState?.selectedModule);

export const selectIsLoadingModules = createSelector(selectModulesState, (moduleState) => moduleState?.loadingModules);

export const selectModulesLoaded = createSelector(selectModulesState, (moduleState) => moduleState?.modulesLoaded);

export const selectIsLoadingModule = createSelector(selectModulesState, (moduleState) => moduleState?.loadingModule);

export const selectModuleLoaded = createSelector(selectModulesState, (moduleState) => moduleState?.moduleLoaded);
